// Teacher / specialist onboarding: a parallel SHORT onboarding track for
// teachers, speech-language therapists and SpEd specialists. It mirrors the
// creator short-path (see creatorOnboarding.js) but asks professional questions
// and ends on the paywall pushing a 1-on-1 setup call.
//
// Entry is either a code (handed out for a call) or the ?teacher=1 link. The
// flag lives in sessionStorage so it dies with the tab and never leaks into the
// normal parent funnel.

const TEACHER_ONBOARDING_CODES = ['TEACHER'];

const FLAG_KEY = 'ttt_teacher_onboarding';

export const isTeacherOnboardingCode = (code) =>
  TEACHER_ONBOARDING_CODES.includes(String(code || '').trim().toUpperCase());

export const setTeacherOnboardingFlag = () => {
  try {
    sessionStorage.setItem(FLAG_KEY, '1');
  } catch {
    // sessionStorage unavailable (private mode quirks): teacher just gets the
    // normal flow, no harm done
  }
};

export const isTeacherOnboardingActive = () => {
  try {
    return sessionStorage.getItem(FLAG_KEY) === '1';
  } catch {
    return false;
  }
};

export const clearTeacherOnboardingFlag = () => {
  try {
    sessionStorage.removeItem(FLAG_KEY);
  } catch {
    // noop
  }
};
